import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-page-calendar',
  templateUrl: './page-calendar.component.html',
  styleUrls: ['./page-calendar.component.css']
})
export class PageCalendarComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
